// extracted by css-extract-rspack-plugin
export default {"item":"gh16r","active":"CGLxl"};